export function initYoutube(className) {
    let youtubePlayButton = $(className);
    youtubePlayButton.unbind('click');
    youtubePlayButton.click(function () {
        convertIntoYoutubeElement($(this));
    });
}

export function convertIntoYoutubeElement(element) {
    const parentElement = element.parent();
    const mainElement = parentElement.parent();
    const imgElement = parentElement.find('img');

    let width = imgElement.width();
    let height = imgElement.height();
    let ytsrc = element.data('ytsrc');
    let uid = element.data('uid');

    const videoElement = $('<iframe id="youtube-video-' + uid + '" class="youtube-video" width="' + width + '" height="' + height + '"\n' +
        'src="https://www.youtube-nocookie.com/embed/' + ytsrc + '?enablejsapi=1&autoplay=1&rel=0&modestbranding=1"\n' +
        'frameborder="0" enablejsapi="1" allowfullscreen allow="autoplay; encrypted-media"></iframe>');

    mainElement.append(videoElement);
    parentElement.remove();
}